// Impor SUBMODUL, bukan `crypto-js` utuh: yang utuh menyeret ~202 KB (SHA-*, HMAC, PBKDF2,
// Rabbit, TripleDES, dst.) ke chunk awal padahal berkas ini cuma AES + UTF-8. Tidak bisa
// dimuat malas seperti sweetalert2 — store membacanya saat boot untuk mendekripsi sesi.
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

// Kunci rahasia untuk enkripsi dan dekripsi
const SECRET_KEY = process.env.VUE_APP_SECRET_KEY;

if (!SECRET_KEY) {
  console.error("SECRET_KEY is not defined in .env file.");
  throw new Error("Missing SECRET_KEY in .env");
}

export const encrypt = (value) => {
  return AES.encrypt(value.toString(), SECRET_KEY).toString();
};

export const decrypt = (encryptedValue) => {
  try {
    const bytes = AES.decrypt(encryptedValue, SECRET_KEY);
    return bytes.toString(Utf8);
  } catch (error) {
    console.error("Error during decryption:", error);
    return null;
  }
};